import React from 'react';
import { Link } from 'react-router-dom';
import { CONSENTS } from '../../data/consentTexts';

/**
 * DSGVO-Einwilligungs-Checkbox (Art. 7) — niemals vorangekreuzt.
 * Props: type (consentTexts key), checked, onChange(bool), testId, dark (für dunkle Hintergründe)
 */
export const ConsentCheckbox = ({ type, checked, onChange, testId, dark = false, className = '' }) => {
  const def = CONSENTS[type];
  if (!def) return null;
  return (
    <label className={`flex items-start gap-2.5 cursor-pointer select-none ${className}`} data-testid={testId || `consent-${type}`}>
      <input
        type="checkbox"
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 w-4 h-4 flex-shrink-0 accent-emerald-600 cursor-pointer"
        data-testid={`${testId || `consent-${type}`}-input`}
      />
      <span className={`text-[11px] leading-relaxed ${dark ? 'text-stone-400' : 'text-stone-500'}`}>
        {def.text}{' '}
        <Link to="/datenschutz" target="_blank" className={`underline ${dark ? 'text-stone-300 hover:text-white' : 'text-stone-700 hover:text-stone-900'}`}>Datenschutzerklärung</Link>
        {type === 'terms_privacy' && (
          <> · <Link to="/agb" target="_blank" className={`underline ${dark ? 'text-stone-300 hover:text-white' : 'text-stone-700 hover:text-stone-900'}`}>AGB</Link></>
        )}
      </span>
    </label>
  );
};

export default ConsentCheckbox;
